module.exports = __webpack_public_path__ + "img/img3.f227df2a.svg";